import { render, staticRenderFns } from "./ListPoint.vue?vue&type=template&id=10834b98&"
import script from "./ListPoint.vue?vue&type=script&lang=js&"
export * from "./ListPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports